import React, {useEffect, useState} from 'react';
import classNames from 'classnames';
import CorrectAnswer from './CorrectAnswer';
import ProgressBar from './ProgressBar';
import ScoreBoard from './Scoreboard';
import SecurityExpert from './SecurityExpert';
import {useTranslation} from 'react-i18next';
import MultipleChoiceAnswer from './MultipleChoiceAnswer';
import SkipVideo from './SkipVideo';

import useGame from '../hooks/useGame';
import VideoFilesFullLoop from './VideoFilesFullLoop';
import MobileVideoButton from './MobileVideoButton';
import { trackPageView } from '../helpers/gaHelper';

const Question1 = () => {
   const { PUBLIC_URL, REACT_APP_LANGUAGE } = process.env;
  const {t} = useTranslation();
  const {addScore, language, trackGTMEvent} = useGame();
  const [slide, setSlide] = useState(0);

  useEffect(() => {
    trackPageView('/question/1');
  },[]);

  // wait
  async function wait(ms) {
    return new Promise(resolve => {
      setTimeout(resolve, ms);
    });
  }

  const [hasAnswered, setHasAnswered] = useState(false);
  const [score, setScore] = useState(4);

  const addBodyClass = className => document.body.classList.add(className);
  const removeBodyClass = className => document.body.classList.remove(className);

  useEffect(() => {
    const show = async () => {
      if (hasAnswered) {
        // show the screen after 1 second
        await wait(1000);
        addBodyClass('fade-in-correct');

        return () => {
          removeBodyClass('fade-in-correct');
        };
      }
    };
    show();
  }, [hasAnswered]);

  const handleAnswer = (isCorrect) => {
    if (isCorrect) {
      setHasAnswered(true);
      addScore(score);
    } else {
      setScore(score - 1);
    }
  };

  // attach the main.js file
  useEffect(() => {
    const script = document.createElement('script');
    script.src = `${PUBLIC_URL}/assets/js/main.js`;
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  // attach the jquery.nicescroll.min.js file
  useEffect(() => {
    const script = document.createElement('script');
    script.src = `${PUBLIC_URL}/assets/js/jquery.nicescroll.min.js`;
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  useEffect(() => {
    trackGTMEvent(1);
  }, []);

  const nextSlide = async (evt) => {
    if (evt.type === 'click' || evt?.keyCode === 13 || evt?.keyCode === 32) {
      let nextSlide = slide + 1;

      if (nextSlide > 2) {
        nextSlide = 0;
      }
      setSlide(nextSlide);
    }    
  };

  const prevSlide = async (evt) => {
    if (evt.type === 'click' || evt?.keyCode === 13 || evt?.keyCode === 32) {
      let prevSlide = slide - 1;
      
      if (prevSlide < 0) {
        prevSlide = 2;
      }
      setSlide(prevSlide);
    }
  };

  return (
    <main>
      <section className="question type-2">
        <div className="inner">
          <ScoreBoard/>
          <ProgressBar question={1}/>
          <SecurityExpert text={t('questions.1.expert')}/>

          <MobileVideoButton className="q1"/>

          <VideoFilesFullLoop page='q1' id='q1-video'/>

          <div className="loop-screen q1"/>
          <SkipVideo/>

          <div className="question-wrapper">
            <div className="inner-wrap">
              <div className="sms-screens">
                <div className="slides">
                  <div alt="message 1" className={classNames({
                      first: true,
                      hand_1: true,
                      [`${language}`]: true,
                      active: slide === 0
                    }                    
                  )}/>

                  <div alt="message 2" className={classNames({
                      hand_2: true,
                      [`${language}`]: true,
                      active: slide === 1
                    }
                  )}/>

                  <div alt="message 3" className={classNames({
                      last: true,
                      hand_3: true,
                      [`${language}`]: true,
                      active: slide === 2
                    }
                  )}/>
                </div>

                <div className="nav">
                  <div tabIndex={0} className="prev" role="button" 
                    onClick={ (evt) => prevSlide(evt)}
                    onKeyDown={(evt) => prevSlide(evt)}/>
                  <div className="option-letter">
                    {slide === 0 && 'A'}
                    {slide === 1 && 'B'}
                    {slide === 2 && 'C'}
                  </div>
                  <div tabIndex={0} className="next" role="button" 
                    onClick={ (evt) => nextSlide(evt)}
                    onKeyDown={(evt) => nextSlide(evt)}/>
                </div>

                <div className="nav-bullets">
                <span role="presentation" onClick={() => setSlide(0)} className={classNames({
                  first: true,
                  active: slide === 0
                })}/>
                  <span role="presentation" onClick={() => setSlide(1)} className={classNames({
                    active: slide === 1
                  })}/>
                  <span role="presentation" onClick={() => setSlide(2)} className={classNames({
                    last: true,
                    active: slide === 2
                  })}/>
                </div>
              </div>
              <div className="select-container">

                <h1>{t('questions.1.title')}</h1>

                <div className="select">
                  <MultipleChoiceAnswer symbol={'A'} isCorrect={false} onClick={handleAnswer}/>
                  <MultipleChoiceAnswer symbol={'B'} isCorrect={false} onClick={handleAnswer}/>
                  <MultipleChoiceAnswer symbol={'C'} isCorrect={false} onClick={handleAnswer}/>
                  <MultipleChoiceAnswer text={t('questions.1.answers.D')} isCorrect={true} onClick={handleAnswer}/>
                </div>

              </div>
            </div>

          </div>

          {hasAnswered && (
            <CorrectAnswer question={1} isPlaying={hasAnswered} scoreTier={5 - score}/>
          )}
        </div>
      </section>
    </main>

  );
};

export default Question1;
